'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var dagPB = require('@ipld/dag-pb');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var get = require('./get.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

function createStat(_ref) {
  var repo = _ref.repo,
      preload = _ref.preload;
  var get$1 = get.createGet({
    repo: repo,
    preload: preload
  });

  function stat(_x) {
    return _stat.apply(this, arguments);
  }

  function _stat() {
    _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
      var options,
          node,
          serialized,
          blockSize,
          linkLength,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _context.next = 3;
              return get$1(cid, options);

            case 3:
              node = _context.sent;
              serialized = dagPB__namespace.encode(node);
              blockSize = serialized.length;
              linkLength = node.Links.reduce(function (a, l) {
                return a + (l.Tsize || 0);
              }, 0);
              return _context.abrupt("return", {
                Hash: cid,
                NumLinks: node.Links.length,
                BlockSize: blockSize,
                LinksSize: blockSize - (node.Data || []).length,
                DataSize: (node.Data || []).length,
                CumulativeSize: blockSize + linkLength
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _stat.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(stat);
}

exports.createStat = createStat;